<!--
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2026-01-04 17:47:53
 * @FilePath: \health-commission-new\src\App.vue
 * @Description: 
-->
<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  created(){
  },
  computed: {
  },
  mounted(){
  },
  methods: {
    
  },
}
</script>

<style>
html,body{
  width: 100%;
  height: 100%;
  margin: 0;
  color: #1B1817;
  background: #F5F5F5;
  overflow-x: hidden;
}
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #111;
}
.wrapper{
  height: 100%;
  overflow-x: hidden;
}
.line-clamp1{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.line-clamp2{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.upload-icon{
  width: 20px;
  height: 20px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA9ZJREFUWEftmN9rj1Ecx9/voly4oCgX1FZEcUFcuCDKBUVRdkF2MSETasWFlT9gRbkhU5MtW7aaEGWLXShFSZQbsjK1C7LiQlFWH72/nWcd5/s853nOtouVndrFnnPO53k9nx/v8zlfYo4PznE+zAPONELT9qCZLQCwA8A+AFsArAOwzAF9ATAG4DmAIZIj0wVNBnRgRwBcBLC64osF2wGgh+Tvintqy5IAzWwtgH4AG1Ne4q19C+AQyQ9V91cGNLPdAAYBLK5qvGCdPHiA5HAVO5UAHdx9AIsCo3qZoPX3muS45s1sJYDNApHHCvZVgiwFdGFVaEK4XgDnSX6NecLMVgC44kD9pT9VXGXhjgKamaBeBDk3CeAMyRtVQpStMbOTAK4CUPVn4yWA7SRlM3eUAcpoZ7CzNRUugAzttZDsmS7gJwAN3uZ+kodTPBeuNbPbAJq958pbSdZAngQVetDMdgF46hlSQTSU5VwZvCsgfbgfam2TuLeRHPBtxAAvqQi8xd0kj5YBVJk3s1sAWgrWKgXOZnkZA1RxbPWMSBYeVAEoW2NmGwA8DNLH39ZJ8pQe1AGamU4JFYe+0JcWhfdz0cvN7CCALjevxC/9GAd6DEBrjow1k+ybAnSScr3A9ZMkF5bA6QjM8kqyoSPtbpk3NW9mOtOfBB5V8TTWAB3cYwA7CwyOklyTN+c858Nly1Ih1Q29CTzZnAEWJa0qV2IqeakT5gjcdCHDwhykyzmR++O9q+DhIpWvAJcMmcMyLsDQe6MANpHUWZk7EuCSIF2q/fJeOinAj0Hj2RRLbifgQ4HQKhXCZkI56Iux/t8T665dM/wnBNQD39BSkj8i3rsTdCa1/k6tfbCnyTW3vu0ukicitnV1eOXNj8mDqYDnAFx2RqaaTzMz/8UkZVva6Fe4uqBrEUC1ZW3efK1IwhBLv/45D32DLgynAeg06CX5zElVHaB7rouVRF9qcDNSdLIn7/mp0iJAibOUPBsqkm2pTUGeB4s8FT43s/UAHgVCreahUYAifxds0i1MjcJILB8Dz+Z6MBJOeUrHqm6Ix3OKrBbJTKhDL+bZVeEUnrFVPWhm+wF0A1gS8XAHyXbN+0fdPclASVgmSC7PW5MA+L0ETgXYXtduOZFUFfn5GLKMk1w1Q8Bv3i8Qvinl/oVQg4vaLbVAahzUZWRVNaFWveg+m+DBve6eo59J1LHoxqgrrVr+ustT6bUzoRKTiqSq3f8K0D+Rog1uVe9NVXHKhoiuSQV0JmvM+HqavWc2Q6xikuhq9KX+zFb04bMGOBtRyLMxDzhTz/4FOQ2k7uoc87IAAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%;
}
</style>
